<style src="./FullView.scss" lang="scss"></style>

<template lang="pug">
  .full-view(
    :class='`is-${type}`'
  )
    .full-view__header
      .full-view__box
        .full-view__cover
          Cover(
            :type='type'
            :cover='cover'
          )

        .full-view__likes(
          v-if='likes'
        )
          Like(
            v-if='active'
            :liked='likes.liked'
            :count='likes.count'
            @like='$emit("like")'
            @unlike='$emit("unlike")'
          )

      .full-view__headline
        .full-view__group
          p.full-view__type {{ label }}
          h1.full-view__title {{ title }}

          .full-view__info-group(
            v-if='year || genres.length || artists.length || country'
          )
            .full-view__info(
              v-if='artists.length'
            )
              .full-view__label {{ $l10n("ARTIST") }}:
              .full-view__artists(
                v-if='artists.length'
              )
                router-link.full-view__artist(
                  v-if='active'
                  v-for='artist in artists'
                  :key='artist.id'
                  :to='`/artists/${artist.id}`'
                ) {{ artist.name }}
                span.full-view__artist(
                  v-else
                  v-for='artist in artists'
                  :key='artist.id'
                ) {{ artist.name }}


            .full-view__info-row(
              v-if='genres.length || year'
            )
              .full-view__year(
                v-if='year'
              ) {{ year }}

              .full-view__genres(
                v-if='genres.length'
              )
                router-link.full-view__genre(
                  v-for='genre in genres'
                  :key='genre.id'
                  :to='`/genres/${genre.id}/${type}s/`'
                ) {{ genre.name }}


            .full-view__info(
              v-if='created'
            )
              .full-view__label {{ $l10n("CREATED") }}:
              .full-view__created {{ created }}

            .full-view__info(
              v-if='country'
            )
              .full-view__label {{ $l10n("COUNTRY") }}:
              .full-view__country {{ country }}

        .full-view__controls(
          v-if='showControls'
        )
          .full-view__play-button(
            @click='$emit("play")'
            v-if='!running && controls.includes("play") && active'
          )
            ControlButton(
              type='play'
              icon='play'
              size='small'
              :text='$l10n("LISTEN")'
            )

          .full-view__play-button(
            @click='$emit("pause")'
            v-if='running && controls.includes("play") && active'
          )
            ControlButton(
              type='pause'
              icon='pause'
              size='small'
              :text='$l10n("STOP")'
            )

          .full-view__context-menu(
            v-if='contextMenu && active'
          )
            ContextMenu(
              :list='contextMenu'
              color='black'
              mode='bordered'
              size='big'
            )

          button.full-view__shuffle-button(
            v-if='controls.includes("shuffle") && active'
            @click='toggleShuffle'
            :class='shuffle ? "is-enabled" : ""'
          )
            Icon(
              name='shuffle'
            )

          button.full-view__repeat-button(
            v-if='controls.includes("repeat") && active'
            @click='toggleRepeat'
            :class='repeat != "none" ? "is-enabled" : ""'
          )
            Icon(
              :name='repeat === "track" ? "repeatOne" : "repeat"'
            )

          .full-view__edit(
            v-if='editable'
          )
            Button(
              :href='editLink'
              :label='$l10n("EDIT")'
              classList='is-bordered is-rounded is-dark is-small is-edit'
            )

          //- button.full-view__delete(
          //-   type='button'
          //-   v-if='removable'
          //-   @click='$emit("delete")'
          //-   :title='$l10n("DELETE")'
          //- )
          //-   Icon(
          //-     name='delete'
          //-   )

    .full-view__body(
      v-if='!active'
    )
      .full-view__notice
        Notice(
          :type='["warn"]'
          :text='$l10n("PAGE_ON_MODERATION")'
        )

</template>

<script>
import Icon from "@/components/Icon/Icon";
import Cover from "@/components/Cover/Cover";
import Button from "@/components/Button/Button";
import ControlButton from "@/components/ControlButton/ControlButton";
import Like from "@/components/Like/Like";
import ContextMenu from "@/components/ContextMenu/ContextMenu";
import Notice from "@/components/Notice/Notice";

import { mapGetters } from "vuex";

const allowedTypes = ["track", "album", "artist", "genre", "playlist"];

export default {
  inheritAttrs: false,
  name: "FullView",
  props: {
    id: String,
    type: {
      type: String,
      validator(value) {
        return allowedTypes.includes(value);
      }
    },
    title: String,
    label: String,
    active: {
      type: [Number, Boolean],
      default: true
    },
    year: [String, Number],
    created: [String, Number],
    likes: Object,
    cover: [Object, Array],
    artists: {
      type: Array,
      default: () => []
    },
    genres: {
      type: Array,
      default: () => []
    },
    country: String,
    running: Boolean,
    showControls: {
      type: Boolean,
      default: true
    },
    controls: {
      type: Array,
      default: () => ["play"]
    },
    editable: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    },
    contextMenu: Array
  },
  components: {
    Icon,
    Cover,
    Button,
    Notice,
    ControlButton,
    Like,
    ContextMenu
  },
  computed: {
    editLink() {
      return this.type === "artist"
        ? "/profile/edit"
        : `/${this.type}s/${this.id}/edit`;
    },
    ...mapGetters({
      repeat: "player/repeat",
      shuffle: "player/shuffle"
    })
  },
  methods: {
    toggleShuffle() {
      this.$player.toggleShuffle();
    },
    toggleRepeat() {
      this.$player.toggleRepeat();
    }
  }
};
</script>
